import React from 'react';
import {getAssetPath} from "../../utils/get-asset-path.js";

const AuthLayout = ({children}) => {
    return (
        <div className="relative h-screen bg-blue-darker overflow-hidden">
            <div
                className="absolute inset-0 h-screen w-screen opacity-20 bg-cover bg-center bg-no-repeat pointer-events-none"
                style={{backgroundImage: `url(${getAssetPath("img/background.webp")})`}}
            />

            <div className="relative z-10 flex flex-col w-full min-h-screen items-center p-4">
                <div className="flex-1 flex items-center justify-center w-full">
                    {children}
                </div>

                <footer className="text-white text-[10px] text-center pb-2">
                    <a href="https://www.sentry.com.br" target="_blank" rel="noreferrer">
                        <img src={getAssetPath("img/logo.svg")} alt="Sentry" title="Sentry" className="w-[150px] mx-auto mb-2"/>
                    </a>
                    © 2004-{new Date().getFullYear()} Multiway Comércio e Representações Ltda.
                    <p className="m-0">Todos os direitos reservados</p>
                </footer>
            </div>
        </div>
    );
};

export default AuthLayout;
